export const makeSearchKey = (rawName: string): string =>
  rawName
    .toLowerCase()
    .trim()
    .replace(/,/g, '')
    .replace(/\s+/g, ' '); 